'use strict';

import $ from 'jquery';

const videojs = require('video.js');
const youtube = require('videojs-youtube');

export default class Hero {
  constructor() {
    this.clickBind();
  }

  clickBind() {
    $('*[data-js="hero-video"]').on('click', (event) => {
      const $delegateTarget = $(event.delegateTarget);
      const ID = $delegateTarget.find('video').get(0).id;
      const player = videojs(ID, { 
        'techOrder': ['html5','youtube']
      });
      player.src({ 
        'type': 'video/youtube', 
        'src': $delegateTarget.find('video').data('youtube')
      });
      
      $delegateTarget.addClass('playing');

      $delegateTarget.find('.video-js').css('display','block');
      $delegateTarget.find('video').css('display','block');

      $delegateTarget.unbind('click');
      player.play();

      player.on('ended', () => {
        this.clickUnbind();
        this.clickBind();
        $delegateTarget.removeClass('playing');
        $delegateTarget.find('.video-js').css('display','none');
        $delegateTarget.find('video').css('display','none');
      });
    });
  }

  clickUnbind() {
    $('*[data-js="hero-video"]').unbind('click');
  }
}
